import React, { useEffect, useState } from 'react';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { ConnectedDialog } from '../../ConnectedDialog';

import { taskSimpleSelectors } from '../../../../app/resource/task-simple/task-simple.selectors';
import {
  clearTaskProps,
  initializeTaskProps,
} from '../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { dialogSelectors } from '../../../../app/dialog/dialog.selectors';
import { ITrelloReplacementFormDialogProps } from './types';
import { checkListsPageSelectors } from '../../../../app/page/page-storage/checklists/checkLists.selectors';
import { activitiesPageSelectors } from '../../../../app/page/page-storage/activities/activities.selectors';
import { Header } from '../../../pages/common/widgets/TaskCard/TaskWidgets/Header';
import { ListName } from '../../../pages/common/widgets/TaskCard/TaskWidgets/ListName';
import { Labels } from '../../../pages/common/widgets/TaskCard/TaskWidgets/Labels';
import { Members } from '../../../pages/common/widgets/TaskCard/TaskWidgets/Members';
import { DueDate } from '../../../pages/common/widgets/TaskCard/TaskWidgets/DueDate';
import { Description } from '../../../pages/common/widgets/TaskCard/TaskWidgets/Description';
import { CheckLists } from '../../../pages/common/widgets/TaskCard/TaskWidgets/CheckLists';
import { Activities } from '../../../pages/common/widgets/TaskCard/TaskWidgets/Activities';
import { CheckListMenu } from '../../../pages/common/widgets/TaskCard/TaskWidgets/TaskMenus/CheckListMenu';
import { AttachmentMenu } from '../../../pages/common/widgets/TaskCard/TaskWidgets/TaskMenus/AttachmentMenu';
import { TaskActions } from '../../../pages/common/widgets/TaskCard/TaskWidgets/TaskActions';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { clearTaskModalStatuses } from '../../../../app/task-modals/task-modals.actions';

export const TrelloReplacementFormDialog: FunctionComponent = () => {
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'trelloReplacementFormDialog',
  ) as ITrelloReplacementFormDialogProps;

  const [newTaskId, setNewTaskId] = useState<string | undefined>(undefined);
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(clearTaskProps());
    dispatch(clearTaskModalStatuses());
    setNewTaskId(undefined);
  }, [dispatch]);

  useEffect(() => {
    if (props && newTaskId) {
      dispatch(initializeTaskProps(newTaskId));
    }
  }, [dispatch, props, newTaskId]);

  useEffect(() => {
    if (props) {
      if (props.taskId) {
        setNewTaskId(props.taskId);
      } else {
        setNewTaskId(undefined);
      }
    }
  }, [props, setNewTaskId]);

  //const labelsIds = useSelect(labelsPageSelectors.selectLabels);
  const checkListsIds = useSelect(checkListsPageSelectors.selectCheckLists);
  const activitiesIds = useSelect(activitiesPageSelectors.selectActivities);

  const taskId = newTaskId;
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');

  let meetingId: IMeetingSimple['id'] | undefined = props ? props.meetingId : undefined;
  if (task) {
    meetingId = task && meetingId && task.meetingIds.includes(meetingId) ? meetingId : task ? task.meetingIds[0] : '';
  }

  return (
    <ConnectedDialog dialogKey="trelloReplacementFormDialog">
      <div className="popup big-popup trello_replacement" style={{ display: 'block' }}>
        <div className="panel">
          {props && meetingId && (
            <Header
              taskId={newTaskId}
              meetingId={meetingId}
              boardListId={props.boardListId}
              onClose={onClose}
              setNewTaskId={setNewTaskId}
            />
          )}
          <div className="panel-body" style={{ position: 'relative' }}>
            {!newTaskId && <div className="overlay-card"></div>}
            <div>
              {props && <ListName taskId={newTaskId} boardListId={props.boardListId} meetingId={meetingId} />}
              <div className="row ais">
                <div className="col-9">
                  <div className="row">
                    {meetingId && <Members menu={false} taskId={newTaskId} meetingId={meetingId} />}
                    {<Labels menu={false} taskId={newTaskId} />}
                    {<DueDate taskId={newTaskId} />}
                  </div>
                  {props && <Description taskId={newTaskId} />}
                  <CheckLists checkListsIds={checkListsIds} />
                  {props && <Activities activitiesIds={activitiesIds} taskId={newTaskId} />}
                </div>
                <div className="col-3 sticky-side">
                  <h5 className="bold">ADD TO CARD</h5>
                  <div className="buttons">
                    {/* {props && <Members menu={true} taskId={newTaskId} meetingId={meetingId} />} */}
                    {props && <CheckListMenu taskId={newTaskId} />}
                    {/* {props && <DueDateMenu taskId={props.taskId} />} */}
                    {/* {props && <AttachmentMenu taskId={newTaskId} />} */}
                  </div>
                  {props && <TaskActions taskId={newTaskId} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
